module.exports = __webpack_public_path__ + "img/PS23.6d5be26c.png";